export const LANGUAGE_STORAGE_KEY = 'naktaraso.language';
export const SUPPORTED_LANGUAGES = ['id', 'en'];
export const DEFAULT_LANGUAGE = 'id';

export function normalizeLanguage(language) {
  const code = String(language || '').toLowerCase().split(/[-_]/)[0];
  return SUPPORTED_LANGUAGES.includes(code) ? code : null;
}

// Explicit choice wins; otherwise use the first supported browser preference.
export function detectLanguage() {
  try {
    const saved = normalizeLanguage(window.localStorage.getItem(LANGUAGE_STORAGE_KEY));
    if (saved) return saved;
  } catch {
    // Browsing with storage disabled must not prevent the site from loading.
  }
  const preferences = navigator.languages?.length ? navigator.languages : [navigator.language];
  return preferences.map(normalizeLanguage).find(Boolean) || DEFAULT_LANGUAGE;
}

export function saveLanguage(language) {
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    // The language still changes for the current visit without persistence.
  }
}
